import { createReducer, requestStatus } from '../../lib/Utils'
import {
  CLEAR_FACEBOOK_AD_TEMPLATES,
  CREATE_AD_CREATIVE_TEMPLATE,
  CREATE_AD_CREATIVE_TEMPLATE_FULFILLED,
  CREATE_AD_CREATIVE_TEMPLATE_REJECTED,
  UPDATE_AD_CREATIVE_TEMPLATE,
  UPDATE_AD_CREATIVE_TEMPLATE_FULFILLED,
  UPDATE_AD_CREATIVE_TEMPLATE_REJECTED,
  CREATE_AD_SET_TEMPLATE,
  CREATE_AD_SET_TEMPLATE_FULFILLED,
  CREATE_AD_SET_TEMPLATE_REJECTED,
  UPDATE_AD_SET_TEMPLATE,
  UPDATE_AD_SET_TEMPLATE_FULFILLED,
  UPDATE_AD_SET_TEMPLATE_REJECTED,
  CREATE_AD_TEMPLATE,
  CREATE_AD_TEMPLATE_FULFILLED,
  CREATE_AD_TEMPLATE_REJECTED,
  GET_AD_CREATIVE_TEMPLATE_PREVIEW_FULFILLED,
  POST_AD_CREATIVE_TEMPLATE_PREVIEW_FULFILLED,
  GET_CHANNEL_CAMPAIGN,
  GET_CHANNEL_CAMPAIGN_FULFILLED,
  GET_CHANNEL_CAMPAIGN_REJECTED,
  GET_TARGETING_FULFILLED,
  GET_AD_SET_TEMPLATE_FULFILLED,
  ACTIVATE_CAMPAIGN,
  ACTIVATE_CAMPAIGN_FULFILLED,
  ACTIVATE_CAMPAIGN_REJECTED,
  RESET_ACTIVATION_STATUS,
  GET_CALLS_TO_ACTION_FULFILLED,
  CREATE_AD_VIDEO,
  CREATE_AD_VIDEO_FULFILLED,
  CREATE_AD_VIDEO_REJECTED,
  GET_AD_VIDEO,
  GET_AD_VIDEO_FULFILLED,
  GET_AD_VIDEO_REJECTED,
  PUSHER_EVENT_AD_VIDEO_PROCESSING,
  GET_RETAILER_AD_CREATIVE_TEMPLATE_FULFILLED,
} from './actions'

const initialState = {
  retailerAdCreativeTemplates: {},
}

export const GENERIC_ERROR_MSG = 'Request failed'

export default createReducer(initialState, {
  [CLEAR_FACEBOOK_AD_TEMPLATES]: (state) => {
    return {
      ...state,
      getChannelCampaignStatus: null,
      createAdCreateTemplateStatus: null,
      createAdCreateTemplateErrors: [],
      createAdSetTemplateStatus: null,
      createAdSetTemplateErrors: [],
      createAdTemplateStatus: null,
      createAdTemplateErrors: [],
      adSetTemplateId: null,
      adTemplateId: null,
      adCreativeTemplateId: null,
      adCreativeTemplates: null,
    }
  },
  [CREATE_AD_CREATIVE_TEMPLATE]: (state) => {
    return {
      ...state,
      createAdCreateTemplateStatus: requestStatus.pending,
      createAdCreateTemplateErrors: null,
    }
  },
  [CREATE_AD_CREATIVE_TEMPLATE_FULFILLED]: (state, action) => {
    return {
      ...state,
      createAdCreateTemplateStatus: requestStatus.complete,
      createAdCreateTemplateErrors: null,
      adCreativeTemplateId: action.payload,
    }
  },
  [CREATE_AD_CREATIVE_TEMPLATE_REJECTED]: (state, action) => {
    let createAdCreateTemplateErrors
    if (action.payload && action.payload.errors) {
      createAdCreateTemplateErrors = action.payload.errors
    } else {
      createAdCreateTemplateErrors = [GENERIC_ERROR_MSG]
    }
    const newState = {
      ...state,
      createAdCreateTemplateStatus: requestStatus.rejected,
      createAdCreateTemplateErrors,
    }
    return newState
  },
  [UPDATE_AD_CREATIVE_TEMPLATE]: (state) => {
    return {
      ...state,
      updateAdCreateTemplateStatus: requestStatus.pending,
      updateAdCreateTemplateErrors: null,
    }
  },
  [UPDATE_AD_CREATIVE_TEMPLATE_FULFILLED]: (state, action) => {
    return {
      ...state,
      updateAdCreateTemplateStatus: requestStatus.complete,
      updateAdCreateTemplateErrors: null,
      adCreativeTemplateId: action.payload,
    }
  },
  [UPDATE_AD_CREATIVE_TEMPLATE_REJECTED]: (state, action) => {
    let updateAdCreateTemplateErrors
    if (action.payload && action.payload.errors) {
      updateAdCreateTemplateErrors = action.payload.errors
    } else {
      updateAdCreateTemplateErrors = [GENERIC_ERROR_MSG]
    }
    const newState = {
      ...state,
      updateAdCreateTemplateStatus: requestStatus.rejected,
      updateAdCreateTemplateErrors,
    }
    return newState
  },
  [CREATE_AD_SET_TEMPLATE]: (state) => {
    return {
      ...state,
      createAdSetTemplateStatus: requestStatus.pending,
      createAdSetTemplateErrors: null,
    }
  },
  [CREATE_AD_SET_TEMPLATE_FULFILLED]: (state, action) => {
    return {
      ...state,
      createAdSetTemplateStatus: requestStatus.complete,
      createAdSetTemplateErrors: null,
      adSetTemplateId: action.payload,
    }
  },
  [CREATE_AD_SET_TEMPLATE_REJECTED]: (state, action) => {
    let createAdSetTemplateErrors
    if (action.payload && action.payload.errors) {
      createAdSetTemplateErrors = action.payload.errors
    } else {
      createAdSetTemplateErrors = [GENERIC_ERROR_MSG]
    }
    const newState = {
      ...state,
      createAdSetTemplateStatus: requestStatus.rejected,
      createAdSetTemplateErrors,
    }
    return newState
  },
  [UPDATE_AD_SET_TEMPLATE]: (state) => {
    return {
      ...state,
      updateAdSetTemplateStatus: requestStatus.pending,
      updateAdSetTemplateErrors: null,
    }
  },
  [UPDATE_AD_SET_TEMPLATE_FULFILLED]: (state, action) => {
    return {
      ...state,
      updateAdSetTemplateStatus: requestStatus.complete,
      updateAdSetTemplateErrors: null,
      adSetTemplateId: action.payload,
    }
  },
  [UPDATE_AD_SET_TEMPLATE_REJECTED]: (state, action) => {
    let updateAdSetTemplateErrors
    if (action.payload && action.payload.errors) {
      updateAdSetTemplateErrors = action.payload.errors
    } else {
      updateAdSetTemplateErrors = [GENERIC_ERROR_MSG]
    }
    const newState = {
      ...state,
      updateAdSetTemplateStatus: requestStatus.rejected,
      updateAdSetTemplateErrors,
    }
    return newState
  },
  [CREATE_AD_TEMPLATE]: (state) => {
    return {
      ...state,
      createAdTemplateStatus: requestStatus.pending,
      createAdTemplateErrors: null,
    }
  },
  [CREATE_AD_TEMPLATE_FULFILLED]: (state, action) => {
    return {
      ...state,
      createAdTemplateStatus: requestStatus.complete,
      createAdTemplateErrors: null,
      adTemplateId: action.payload,
    }
  },
  [CREATE_AD_TEMPLATE_REJECTED]: (state, action) => {
    let createAdTemplateErrors
    if (action.payload && action.payload.errors) {
      createAdTemplateErrors = action.payload.errors
    } else {
      createAdTemplateErrors = [GENERIC_ERROR_MSG]
    }
    const newState = {
      ...state,
      createAdTemplateStatus: requestStatus.rejected,
      createAdTemplateErrors,
    }
    return newState
  },
  [GET_AD_CREATIVE_TEMPLATE_PREVIEW_FULFILLED]: (state, action) => {
    const response = action.payload
    const {
      adCreativeTemplateId,
      facebookPageId,
      adType,
      requestDate,
    } = action.meta
    const adCreativeTemplatePreviews = {
      ...(state.adCreativeTemplatePreviews || {}),
    }

    if (!adCreativeTemplatePreviews[adCreativeTemplateId]) {
      adCreativeTemplatePreviews[adCreativeTemplateId] = {}
    }
    if (!adCreativeTemplatePreviews[adCreativeTemplateId][facebookPageId]) {
      adCreativeTemplatePreviews[adCreativeTemplateId][facebookPageId] = {}
    }
    if (
      !adCreativeTemplatePreviews[adCreativeTemplateId][facebookPageId][adType]
    ) {
      adCreativeTemplatePreviews[adCreativeTemplateId][facebookPageId][
        adType
      ] = {}
    }

    adCreativeTemplatePreviews[adCreativeTemplateId][facebookPageId][adType] = [
      { ...response[0], lastUpdate: requestDate },
    ]

    const newState = { ...state, adCreativeTemplatePreviews }
    return newState
  },
  [POST_AD_CREATIVE_TEMPLATE_PREVIEW_FULFILLED]: (state, action) => {
    const { iframe, adcreative_template_id } = action.payload
    const iframeHtml = {
      ...state.iframeHtml,
      [adcreative_template_id]: iframe,
    }
    const newState = { ...state, iframeHtml }
    return newState
  },
  [GET_CALLS_TO_ACTION_FULFILLED]: (state, action) => {
    const callsToAction = action.payload.response
    return {
      ...state,
      callsToAction,
    }
  },
  [GET_CHANNEL_CAMPAIGN]: (state) => {
    return {
      ...state,
      getChannelCampaignStatus: requestStatus.pending,
      getChannelCampaignErrors: null,
    }
  },
  [GET_CHANNEL_CAMPAIGN_FULFILLED]: (state, action) => {
    const channelCampaigns = { ...(state.channelCampaigns || {}) }
    let data = action.payload.response

    // TODO: Remove this after API changes response to return object, not array
    // Currently, returns an array of 1 object
    if (Array.isArray(action.payload.response)) {
      data = action.payload.response[0]
    }

    channelCampaigns[action.payload.channelCampaignId] = data

    const newState = {
      ...state,
      getChannelCampaignStatus: requestStatus.complete,
      getChannelCampaignErrors: null,
      channelCampaigns,
    }
    return newState
  },
  [GET_CHANNEL_CAMPAIGN_REJECTED]: (state, action) => {
    let getChannelCampaignErrors
    if (action.payload && action.payload.errors) {
      getChannelCampaignErrors = action.payload.errors
    } else {
      getChannelCampaignErrors = [GENERIC_ERROR_MSG]
    }
    const newState = {
      ...state,
      getChannelCampaignStatus: requestStatus.rejected,
      getChannelCampaignErrors,
    }
    return newState
  },
  [GET_TARGETING_FULFILLED]: (state, action) => {
    const newState = { ...state, targeting: action.payload }
    return newState
  },
  [GET_AD_SET_TEMPLATE_FULFILLED]: (state, action) => {
    //This end point can support fetching by brand id or retailer id and we just want to ensure we group them separately.
    const { adSetTemplateId, retailerId, brandId } = action.payload
    const adSetTemplates = { ...(state.adSetTemplates || {}) }
    let type
    let sourceId
    if (retailerId) {
      type = 'retailer'
      sourceId = retailerId
    } else {
      type = 'brand'
      sourceId = brandId
    }

    if (!adSetTemplates[type]) {
      adSetTemplates[type] = {}
    }

    if (!adSetTemplates[type][sourceId]) {
      adSetTemplates[type][sourceId] = {}
    }

    adSetTemplates[type][sourceId][adSetTemplateId] = action.payload.response

    const newState = { ...state, adSetTemplates }
    return newState
  },
  [ACTIVATE_CAMPAIGN]: (state, action) => {
    const { campaignId } = action.payload
    const { activateCampaignRequestsById = {} } = state
    return {
      ...state,
      activateCampaignRequestsById: {
        ...activateCampaignRequestsById,
        [campaignId]: {
          status: requestStatus.pending,
          errors: null,
        },
      },
    }
  },
  [ACTIVATE_CAMPAIGN_FULFILLED]: (state, action) => {
    const { activateCampaignRequestsById = {} } = state
    const { campaignId } = action.payload
    return {
      ...state,
      activateCampaignRequestsById: {
        ...activateCampaignRequestsById,
        [campaignId]: {
          status: requestStatus.complete,
          errors: null,
        },
      },
    }
  },
  [ACTIVATE_CAMPAIGN_REJECTED]: (state, action) => {
    const { campaignId } = action.payload
    const { activateCampaignRequestsById = {} } = state
    let errors
    if (action.payload instanceof Error) {
      return state
    } else {
      const { response } = action.payload
      if (response) {
        errors = response
      } else {
        errors = [GENERIC_ERROR_MSG]
      }
    }

    return {
      ...state,
      activateCampaignRequestsById: {
        ...activateCampaignRequestsById,
        [campaignId]: {
          status: requestStatus.rejected,
          errors,
        },
      },
    }
  },
  [RESET_ACTIVATION_STATUS]: (state) => {
    return {
      ...state,
      activateCampaignRequestsById: undefined,
    }
  },
  [CREATE_AD_VIDEO]: (state, action) => {
    const { brandId, sourceId } = action.payload

    if (!brandId || !sourceId) {
      return state
    }

    const { createAdVideoRequestsByBrandId = {} } = state

    return {
      ...state,
      createAdVideoRequestsByBrandId: {
        ...createAdVideoRequestsByBrandId,
        [brandId]: {
          ...createAdVideoRequestsByBrandId[brandId],
          [sourceId]: {
            status: requestStatus.pending,
            errors: null,
          },
        },
      },
    }
  },
  [CREATE_AD_VIDEO_FULFILLED]: (state, action) => {
    const { brandId, sourceId } = action.meta

    if (!brandId || !sourceId) {
      return state
    }

    const { createAdVideoRequestsByBrandId = {} } = state
    const { adVideo = {} } = state
    return {
      ...state,
      createAdVideoRequestsByBrandId: {
        ...createAdVideoRequestsByBrandId,
        [brandId]: {
          ...createAdVideoRequestsByBrandId[brandId],
          [sourceId]: {
            status: requestStatus.complete,
            errors: null,
            ...action.payload,
          },
        },
      },
      adVideo: {
        ...adVideo,
        [action.payload.id]: {
          ...adVideo[action.payload.id],
          ...action.payload,
          brandId,
        },
      },
    }
  },
  [CREATE_AD_VIDEO_REJECTED]: (state, action) => {
    const { brandId, sourceId } = action.meta

    if (!brandId || !sourceId) {
      return state
    }

    let errors
    if (action.payload instanceof Error) {
      return state
    } else {
      const { response } = action.payload
      if (response) {
        errors = response
      } else {
        errors = [GENERIC_ERROR_MSG]
      }
    }

    const { createAdVideoRequestsByBrandId = {} } = state

    return {
      ...state,
      createAdVideoRequestsByBrandId: {
        ...createAdVideoRequestsByBrandId,
        [brandId]: {
          ...createAdVideoRequestsByBrandId[brandId],
          [sourceId]: {
            status: requestStatus.rejected,
            errors,
          },
        },
      },
    }
  },
  [GET_AD_VIDEO]: (state, action) => {
    const { getAdVideoRequests = {} } = state

    return {
      ...state,
      getAdVideoRequests: {
        ...getAdVideoRequests,
        [action.payload.videoId]: {
          status: requestStatus.pending,
          errors: null,
        },
      },
    }
  },
  [GET_AD_VIDEO_FULFILLED]: (state, action) => {
    const { getAdVideoRequests = {}, adVideo = {} } = state

    return {
      ...state,
      getAdVideoRequests: {
        ...getAdVideoRequests,
        [action.meta.videoId]: {
          status: requestStatus.complete,
          errors: null,
        },
      },
      adVideo: {
        ...adVideo,
        [action.meta.videoId]: {
          ...adVideo[action.meta.videoId],
          ...action.payload,
        },
      },
    }
  },
  [GET_AD_VIDEO_REJECTED]: (state, action) => {
    const { getAdVideoRequests = {}, adVideo = {} } = state
    let errors
    if (action.payload instanceof Error) {
      return state
    } else {
      const { response } = action.payload
      if (response) {
        errors = response
      } else {
        errors = [GENERIC_ERROR_MSG]
      }
    }

    return {
      ...state,
      getAdVideoRequests: {
        ...getAdVideoRequests,
        [action.meta.videoId]: {
          status: requestStatus.rejected,
          errors,
        },
      },
      adVideo: {
        ...adVideo,
        [action.meta.videoId]: {
          ...adVideo[action.meta.videoId],
          error_code: action.payload.code,
        },
      },
    }
  },
  [PUSHER_EVENT_AD_VIDEO_PROCESSING]: (state, action) => {
    const { adVideo = {} } = state
    const { data = {} } = action.payload

    if (!data.id) {
      return state
    }

    return {
      ...state,
      adVideo: {
        ...adVideo,
        [data.id]: {
          ...adVideo[data.id],
          ...data,
        },
      },
    }
  },
  [GET_RETAILER_AD_CREATIVE_TEMPLATE_FULFILLED]: (state, action) => ({
    ...state,
    retailerAdCreativeTemplates: {
      ...state.retailerAdCreativeTemplates,
      [`${action.meta.retailerId}-${action.meta.id}`]: action.payload,
    },
  }),
})
